import React, { useContext, useState, useEffect } from "react";
import "../../css/home/home.css";
import Logo from "../../assets/logos/LogoColurs.png";
import { UtilContext } from "../../context/UtilContext";
import NavbarRegistro from "../../components/navbar/NavbarRegistro";
import BecomeButton from "../../components/button/BecomeButton";
import ColorsMain from "../../colors/ColorsMain";
import { useParams, useLocation } from "react-router-dom";
import axios from "axios";
import StatusVerification from "../../components/layouts/StatusVerification";
import CryptoJS from "crypto-js";

const VerificationBecomeUser = () => {
  const secretKey = process.env.REACT_APP_HASH;
  const { language } = useContext(UtilContext);
  const { id } = useParams();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const nombre = queryParams.get("name");

  const [becomeData, setBecomeData] = useState(null);
  const [Status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [timer, setTimer] = useState(45); // Temporizador inicial de 45 segundos

  const fechData = async () => {
    const revertedEncryptedId = id.replace(/-/g, "+").replace(/_/g, "/");
    const decryptedBytes = await CryptoJS.AES.decrypt(revertedEncryptedId, secretKey);
    const idFinal = decryptedBytes.toString(CryptoJS.enc.Utf8);

    await axios
      .post(`/verify_identity`, { id: idFinal })
      .then((response) => {
        if (response.data.status === 200) {
          setBecomeData(response.data.data);
        }
      })
      .catch((error) => console.error(error));
  };

  const fechDataStatus = async () => {
    const revertedEncryptedId = id.replace(/-/g, "+").replace(/_/g, "/");
    const decryptedBytes = await CryptoJS.AES.decrypt(revertedEncryptedId, secretKey);
    const idFinal = decryptedBytes.toString(CryptoJS.enc.Utf8);

    if (Status === 5) return;
    setLoading(true);
    await axios
      .post(`/verify_identity/status`, { id: idFinal })
      .then((response) => {
        if (response.data.status === 200) {
          setStatus(response.data.data.level);
        }
      })
      .catch((error) => console.error(error));
    setLoading(false);
  };

  useEffect(() => {
    const intervalId = setInterval(() => fechDataStatus(), 45000); // Actualiza cada 45 segundos
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const countdown = setInterval(() => {
      setTimer((prev) => (prev > 0 ? prev - 1 : 45)); // Reinicia a 45 si llega a 0
    }, 1000);

    return () => clearInterval(countdown);
  }, []);

  useEffect(() => {
    fechData();
    fechDataStatus();
  }, []);

  return (
    <div className="w-auto flex flex-col bg-[#1B1B22] min-h-screen p-4 md:p-11 justify-center">
      <div className="w-full flex items-center justify-center">
        <div className="w-full max-w-md md:max-w-lg h-auto flex items-center text-center flex-col justify-center gap-8 p-6 md:p-8 rounded-2xl shadow-2xl shadow-[#111111] bg-[ColorsMain.bgButtonBlack]">
          <img src={Logo} className="w-12 h-12" alt="Colurs Logo" />
          <div>
            <h2
              className="text-xl md:text-2xl mt-4 text-white"
              style={{ fontFamily: "brico" }}
            >
              Verificación de identidad
            </h2>
            <p className="text-sm md:text-base text-[#B7B7B9] mt-2">
              Hola <span className="text-white">{`${nombre}`}</span> tus datos han sido registrados para ser beneficiario Colurs.
              <br />
              Necesitamos que verifiques tu identidad para completar el proceso.
            </p>
          </div>
          <div>
            {becomeData && Status != null && Status !== 5 && Status !== 1 && !loading && (
              <BecomeButton
                BecomeDataStatysFetch={fechDataStatus}
                token={becomeData.token}
                userId={becomeData.user_id}
                contractId={becomeData.contract_id}
              />
            )}
            {loading && (
              <div className="spinner-border-white animate-spin w-5 h-5 border-2 border-t-transparent rounded-full border-white"></div>
            )}
            {Status !== 0 && Status != null && !loading && <StatusVerification status={Status} />}

            {Status === 1 && (
              <p className="text-sm text-[#B7B7B9] mt-2">
                En{" "}
                <span className="text-white inline-block w-[2ch] text-center">
                  {timer}
                </span>{" "}
                segundos se realizará una nueva consulta para verificar si hubo cambios en el estado.
              </p>
            )}
          </div>
          <p className="text-sm md:text-base text-[#B7B7B9]">
            Si tienes dudas o preguntas, no dudes en{" "}
            <a
              href="https://colurs.odoo.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white underline"
            >
              contactar a nuestro equipo
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default VerificationBecomeUser;
